import { render, staticRenderFns } from "./a-product-attribute.vue?vue&type=template&id=cac43b56&"
import script from "./a-product-attribute.vue?vue&type=script&lang=js&"
export * from "./a-product-attribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports